<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PRODUCT_ORDERS.show_order") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="orderData">
      <form>
        <div class="row">
          <!-- ============ Start:: Order Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("PRODUCT_ORDERS.order_data_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.order_number')"
            v-model.trim="orderData.id"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.order_date')"
            v-model.trim="orderData.created_at"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.order_status')"
            v-model.trim="orderData.status_label"
            disabled
          />
          <!-- ============ End:: Order Data Section ============ -->

          <!-- ============ Start:: Customer Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData.user">
            <h4>{{ $t("PRODUCT_ORDERS.customer_data_section") }}</h4>
          </div>

          <template v-if="orderData.user">
            <base-image-upload-input
              col="12"
              :disabled="true"
              identifier="user_avatar"
              :placeholder="$t('PRODUCT_ORDERS.customer_image')"
              :preSelectedImage="orderData.user?.avatar"
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.customer_name')"
              v-model.trim="orderData.user.name"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.average_rating')"
              v-model.trim="orderData.user.rating"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.city')"
              v-model.trim="orderData.user.city"
              disabled
            />

            <!-- Customer Location Map -->
            <div
              class="col-12"
              v-if="orderData.user.latitude && orderData.user.longitude"
            >
              <label class="mb-2">{{
                $t("PRODUCT_ORDERS.location_map")
              }}</label>
              <MapComponent
                :lat="parseFloat(orderData.user.latitude)"
                :lng="parseFloat(orderData.user.longitude)"
              />
            </div>
          </template>
          <!-- ============ End:: Customer Data Section ============ -->

          <!-- ============ Start:: Provider (Store) Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData.provider">
            <h4>{{ $t("PRODUCT_ORDERS.provider_data_section") }}</h4>
          </div>

          <template v-if="orderData.provider">
            <base-image-upload-input
              col="12"
              :disabled="true"
              identifier="provider_avatar"
              :placeholder="$t('PRODUCT_ORDERS.store_logo')"
              :preSelectedImage="orderData.provider?.avatar"
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.store_name')"
              v-model.trim="orderData.provider.name"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.average_rating')"
              v-model.trim="orderData.provider.rating"
              disabled
            />

            <base-input
              col="4"
              type="text"
              :placeholder="$t('PRODUCT_ORDERS.city')"
              v-model.trim="orderData.provider.city"
              disabled
            />

            <!-- Provider Location Map -->
            <div
              class="col-12"
              v-if="orderData.provider.latitude && orderData.provider.longitude"
            >
              <label class="mb-2">{{
                $t("PRODUCT_ORDERS.location_map")
              }}</label>
              <MapComponent
                :lat="parseFloat(orderData.provider.latitude)"
                :lng="parseFloat(orderData.provider.longitude)"
              />
            </div>
          </template>
          <!-- ============ End:: Provider (Store) Data Section ============ -->

          <!-- ============ Start:: Additional Details Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("PRODUCT_ORDERS.additional_details_section") }}</h4>
          </div>

          <!-- Pickup Location Map -->
          <div class="col-12" v-if="orderData.latitude && orderData.longitude">
            <label class="mb-2">{{
              $t("PRODUCT_ORDERS.pickup_location")
            }}</label>
            <MapComponent
              :lat="parseFloat(orderData.latitude)"
              :lng="parseFloat(orderData.longitude)"
            />
          </div>

          <base-input
            v-if="orderData.location"
            col="12"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.pickup_location')"
            v-model.trim="orderData.location"
            disabled
          />

          <base-input
            col="12"
            type="textarea"
            rows="3"
            :placeholder="$t('PRODUCT_ORDERS.notes')"
            v-model.trim="orderData.notes"
            disabled
          />

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.number_of_products')"
            :value="orderData.products ? orderData.products.length : 0"
            disabled
          />
          <!-- ============ End:: Additional Details Section ============ -->

          <!-- ============ Start:: Products List Section ============ -->
          <div
            class="form_title_wrapper"
            v-if="orderData.products && orderData.products.length"
          >
            <h4>{{ $t("PRODUCT_ORDERS.products_list_section") }}</h4>
          </div>

          <template v-if="orderData.products && orderData.products.length">
            <div
              class="col-12 product_card"
              v-for="(product, index) in orderData.products"
              :key="index"
            >
              <div class="product_header">
                <h5>
                  {{ $t("PRODUCT_ORDERS.product") }} #{{ index + 1 }}
                </h5>
              </div>

              <div class="row">
                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.product_name')"
                  v-model.trim="product.name"
                  disabled
                />

                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.product_condition')"
                  v-model.trim="product.condition_label"
                  disabled
                />

                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.main_category')"
                  :value="product.main_category ? product.main_category.name : '-'"
                  disabled
                />

                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.subcategory')"
                  :value="product.subcategory ? product.subcategory.name : '-'"
                  disabled
                />

                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.product_price')"
                  :value="
                    product.price
                      ? product.price + ' ' + $t('PLACEHOLDERS.riyal')
                      : '-'
                  "
                  disabled
                />

                <base-input
                  v-if="product.has_discount"
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.discount_value')"
                  :value="
                    product.price_after_discount
                      ? (product.price - product.price_after_discount) +
                        ' ' +
                        $t('PLACEHOLDERS.riyal')
                      : '-'
                  "
                  disabled
                />

                <base-input
                  col="4"
                  type="text"
                  :placeholder="$t('PRODUCT_ORDERS.product_rating')"
                  v-model.trim="product.rating"
                  disabled
                />

                <base-input
                  col="12"
                  type="textarea"
                  rows="3"
                  :placeholder="$t('PRODUCT_ORDERS.product_description')"
                  v-model.trim="product.description"
                  disabled
                />

                <!-- Product Images -->
                <div
                  class="col-12"
                  v-if="product.images && product.images.length"
                >
                  <label class="mb-2">{{
                    $t("PRODUCT_ORDERS.product_images")
                  }}</label>
                  <div class="images_gallery">
                    <img
                      v-for="(image, imgIndex) in product.images"
                      :key="imgIndex"
                      :src="image.url"
                      :alt="`Product Image ${imgIndex + 1}`"
                      class="product_image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- ============ End:: Products List Section ============ -->

          <!-- ============ Start:: Price and Payment Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("PRODUCT_ORDERS.price_payment_section") }}</h4>
          </div>

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.payment_method')"
            :value="getPaymentMethodLabel(orderData.payment_method)"
            disabled
          />

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.products_subtotal')"
            :value="
              orderData.sub_total
                ? orderData.sub_total + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.delivery_cost')"
            :value="
              orderData.delivery_price
                ? orderData.delivery_price + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.total_incl_delivery')"
            :value="
              orderData.sub_total_with_discount
                ? orderData.sub_total_with_discount + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.tax')"
            :value="
              orderData.tax
                ? orderData.tax + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PRODUCT_ORDERS.total_incl_tax')"
            :value="
              orderData.total
                ? orderData.total + ' ' + $t('PLACEHOLDERS.riyal')
                : '-'
            "
            disabled
          />
          <!-- ============ End:: Price and Payment Data Section ============ -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import MapComponent from "../../../components/general/MapComponent.vue";

export default {
  name: "ShowProductOrders",
  components: {
    MapComponent,
  },

  data() {
    return {
      isWaitingRequest: false,
      orderData: {
        user: {},
        provider: {},
        products: [],
      },
    };
  },

  methods: {
    // Start:: Show Order
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        this.orderData = res.data.data.order;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || "Error loading order"
        );
      }
    },
    // End:: Show Order

    // Start:: Get Payment Method Label
    getPaymentMethodLabel(method) {
      if (method === "wallet") {
        return this.$t("PAYMENT_METHODS.wallet");
      } else if (method === "online" || method === "electronic") {
        return this.$t("PAYMENT_METHODS.electronic");
      }
      return method;
    },
    // End:: Get Payment Method Label
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.form_title_wrapper {
  margin-top: 20px;
  margin-bottom: 15px;
}

.product_card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product_header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #dee2e6;
}

.product_header h5 {
  color: #495057;
  font-weight: 600;
  margin: 0;
}

.images_gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.product_image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

label.mb-2 {
  font-weight: 600;
  color: #333;
  display: block;
}
</style>
